import { mixTimelineItems } from './timelinePresentation';
export const decades = [1950, 1960, 1970, 1980, 1990, 2000, 2010, 2020];
export function timelineFilters(params, now = new Date().getFullYear()) {
  const raw = Number(params.get('decade'));
  const decade = decades.includes(raw) ? raw : 1990;
  const rawYear = Number(params.get('year'));
  const year =
    Number.isInteger(rawYear) && rawYear >= decade && rawYear <= Math.min(decade + 9, now)
      ? rawYear
      : undefined;
  const section = ['rediscovered', 'opening'].includes(params.get('section'))
    ? params.get('section')
    : undefined;
  const region =
    section === 'opening'
      ? 'global'
      : ['kr', 'all'].includes(params.get('region'))
        ? params.get('region')
        : 'global';
  return { decade, year, section, region };
}
export function timelineTitle({ decade, year, section, region }, locale) {
  const period = year
    ? `${year}${locale === 'ko' ? '년' : ''}`
    : `${decade}${locale === 'ko' ? '년대' : 's'}`;
  const place =
    locale === 'ko' ? (region === 'kr' ? '국내' : '해외') : region === 'kr' ? 'Korea' : 'Global';
  return locale === 'ko'
    ? `${section === 'opening' ? '' : '다시 찾는 '}${period} ${section === 'opening' ? '대표 앨범' : '앨범'} ${place}`
    : `${section === 'opening' ? 'Essential' : 'Rediscovering'} ${period} Albums · ${place}`;
}
export function timelinePath(filters) {
  return `/explore/timeline?${new URLSearchParams(Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== undefined)))}`;
}
export function timelineNext(page, section) {
  if (
    !Number.isSafeInteger(page.page) ||
    page.page < 1 ||
    !(section === 'opening' ? page.hasMoreOpening : page.hasMoreRediscovered)
  )
    return undefined;
  const next = page.resumePage ?? page.page + 1;
  return Number.isSafeInteger(next) && next > 0 ? next : undefined;
}
export function timelineItems(pages, { section, region }) {
  const seen = new Set();
  return pages
    .flatMap((p) => p[section === 'opening' ? 'openingAlbums' : 'rediscoveredAlbums'] || [])
    .filter((item) => {
      const domestic = item.album.displayRegion?.toUpperCase() === 'KR';
      if ((region !== 'all' && (region === 'kr') !== domestic) || seen.has(item.album.id))
        return false;
      seen.add(item.album.id);
      return true;
    });
}
export async function loadTimelineOverview(read, { decade, year }, signal) {
  const filters = [
    { decade, year, region: 'kr', section: 'rediscovered' },
    { decade, year, region: 'global', section: 'rediscovered' },
    ...(decade === 1950 ? [] : [{ decade, year, region: 'global', section: 'opening' }]),
  ];
  return Promise.all(
    filters.map(async (filter) => {
      const data = await read({ ...filter, size: filter.section === 'opening' ? 12 : 24 }, signal);
      return {
        filter,
        items:
          filter.section === 'opening'
            ? (data.openingAlbums || []).slice(0, 12).map((item) => ({ item }))
            : mixTimelineItems(data.rediscoveredAlbums || []),
      };
    }),
  );
}
